import { isDefined } from '@follow/cdk'
import { EFFICIENCE_APP_URL } from '../environment/efficience'
import { CustomFile } from '../model/File'
import { DmpRequestTypes, FileForDMP } from '../store/domain/dmp'
import { parseFiniteNumber } from './math.utilities'

export const openDMP = () => {
  window.open(EFFICIENCE_APP_URL)
}

export const DMP_SERVICES_ACCEPTED_EXTENSIONS = ['jpeg', 'jpg', 'tiff', 'pdf', 'rtf', 'plain']

export const mapFileForDMP = (pendingFile: CustomFile): FileForDMP | undefined => {
  const { id, visibleName, base64, dmpId, version, createdAt, loincCode, extension } = pendingFile

  if (!base64) return

  return {
    id,
    base64,
    createdAt,
    loincCode,
    format: extension === 'jpg' ? 'jpeg' : extension,
    name: visibleName,
    dmpDocumentId: dmpId,
    version: version.toString(),
  }
}

const REQUEST_ID_DIVIDER = ':'

export const computeEfficienceRequestId = (type: DmpRequestTypes, fileId?: number): string => {
  if (isDefined(fileId)) {
    return `${type}${REQUEST_ID_DIVIDER}${fileId}`
  } else {
    return type
  }
}
export const parseEfficienceRequestId = (requestId: string) => {
  if (!requestId) return null

  const splited = requestId.split(REQUEST_ID_DIVIDER)
  const type = splited.at(0) as DmpRequestTypes

  if (!type || !Object.values(DmpRequestTypes).includes(type)) return null

  const fileId = parseFiniteNumber(splited.at(1) ?? '')

  return {
    type,
    fileId,
  }
}
